import React from "react";
import { LegalPageLayout } from "./LegalPageLayout";

const sections = [
  {
    title: "1. Acceptance of These Terms",
    paragraphs: [
      'By using Echo MSG for WhatsApp, you agree to these Terms of Service and our Privacy Policy. If you do not agree, please do not use the service.',
      "These Terms apply whether you use the free version, a referral bonus, a trial period, or a paid subscription.",
    ],
  },
  {
    title: "2. What the Service Does",
    paragraphs: [
      "Echo MSG lets users send WhatsApp voice notes for transcription into text and images for extraction of visible text. Depending on the feature used, Echo MSG may also return a short summary or action item, convert text into audio, and offer referral rewards, free usage allowances, or paid subscription plans.",
      "We may change, improve, limit, or remove features over time.",
    ],
  },
  {
    title: "3. Eligibility and Account Use",
    bullets: [
      "You must be legally allowed to use the service where you are located.",
      "If you are under 16, you should use Echo MSG only with the supervision of a parent or legal guardian.",
      "You are responsible for the phone number or account you use to access the service.",
      "You should not share paid access in a way that abuses or misuses the service.",
    ],
  },
  {
    title: "4. Your Responsibilities",
    bullets: [
      "Only submit content that you have the right to send and process.",
      "Do not send unlawful, abusive, threatening, defamatory, fraudulent, or otherwise harmful content.",
      "Do not use Echo MSG to spam, harass, reverse engineer, interfere with, or overload the service.",
      "Do not send highly sensitive or confidential material unless you are comfortable with it being processed by the service and its providers.",
      "You are responsible for reviewing transcriptions, extracted image text, summaries, and audio outputs before relying on them.",
    ],
  },
  {
    title: "5. Accuracy, AI Output, and Availability",
    paragraphs: [
      "Echo MSG uses automated systems and third-party AI tools. That means transcriptions, extracted image text, summaries, and related outputs can contain mistakes, omissions, or formatting issues.",
      "The service is provided on an as-is and as-available basis. We do not guarantee uninterrupted access, perfect accuracy, or that every message will be processed successfully.",
    ],
  },
  {
    title: "6. Subscriptions, Billing, and Auto-Renewal",
    paragraphs: [
      "Echo MSG may offer monthly or yearly paid plans. Prices are shown before checkout and may change in the future.",
      "People who first contact Echo MSG through a Meta Click to WhatsApp ad receive one free conversion before payment is required for further use. Their subscription price may be different from the standard price; the applicable amount is shown in the WhatsApp offer and again at checkout.",
      "Paid subscriptions are processed through PayFast. By starting a paid subscription, you authorize recurring charges at the billing interval you selected until you cancel.",
      "To avoid the next renewal charge, please request cancellation before your renewal date by emailing echomsgteam@gmail.com, unless we provide another cancellation method later. If you cancel, your access will usually continue until the end of the period you already paid for and then stop renewing.",
      "Payments are handled by PayFast and may also be subject to PayFast's own terms and privacy practices. Echo MSG does not store full card details.",
      "Unless required by law or stated otherwise, fees already charged are non-refundable. Failed, reversed, or disputed payments may lead to suspension or cancellation of paid access.",
      "Free limits, trial allowances, referral bonuses, and subscription benefits may change over time.",
    ],
  },
  {
    title: "7. Privacy and Data Handling",
    paragraphs: [
      "Our Privacy Policy explains what information we collect and how we handle it. By using Echo MSG, you also agree to that policy.",
      "In short, we keep account and usage metadata needed to operate the service, while message content is designed to be processed transiently rather than stored as a permanent chat archive in our database.",
      "If we send occasional WhatsApp marketing or win-back messages, you can opt out of those non-essential messages at any time by replying STOP.",
    ],
  },
  {
    title: "8. Intellectual Property",
    paragraphs: [
      "Echo MSG and its branding, software, site design, and service materials remain the property of Echo MSG or its licensors.",
      "You keep your rights to the content you submit. By using the service, you give us a limited, non-exclusive permission to process your content only to provide the service to you.",
    ],
  },
  {
    title: "9. Suspension and Termination",
    paragraphs: [
      "We may suspend, limit, or stop providing the service to you if we believe you have breached these Terms, created legal or security risk, abused the service, or used it fraudulently.",
      "You may stop using the service at any time.",
    ],
  },
  {
    title: "10. Limitation of Liability",
    paragraphs: [
      "To the maximum extent permitted by law, Echo MSG is not liable for indirect, incidental, special, consequential, or punitive losses, or for lost profits, lost business, lost data, or decisions you make based on transcriptions or summaries.",
      "If the law allows a limit on direct liability, Echo MSG's liability will be limited to the amount you paid us for the service giving rise to the claim, if any.",
    ],
  },
  {
    title: "11. Changes to These Terms",
    paragraphs: [
      "We may update these Terms from time to time. When we do, we will post the updated version on this page. Continued use of Echo MSG after an update means you accept the revised Terms.",
    ],
  },
  {
    title: "12. Contact",
    paragraphs: [
      "If you have questions about these Terms or your subscription, contact echomsgteam@gmail.com.",
    ],
  },
];

const TermsOfService = () => {
  return (
    <LegalPageLayout
      title="Terms of Service"
      lastUpdated="October 3, 2026"
      introTitle="Plain-English Terms for Using Echo MSG"
      introParagraphs={[
        "These terms explain the main rules for using Echo MSG, including paid subscriptions. They are written to be readable, but they are still a legal agreement between you and Echo MSG.",
      ]}
      sections={sections}
    />
  );
};

export default TermsOfService;
